import apiClient, { getApiErrorMessage } from './apiClient';

const unwrapApiData = (data) => data?.data || data?.Data || data;

export const uploadMediaApi = async (file) => {
  if (!(file instanceof File)) {
    throw new Error('A valid file is required.');
  }

  const formData = new FormData();
  formData.append('file', file);

  try {
    const { data } = await apiClient.post('/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    const payload = unwrapApiData(data);
    return {
      url: payload?.Url || payload?.url || '',
      objectKey: payload?.ObjectKey || payload?.objectKey || '',
      fileName: payload?.FileName || payload?.fileName || file.name,
      contentType: payload?.ContentType || payload?.contentType || file.type
    };
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Upload failed.'));
  }
};

export const uploadMediaFilesApi = async (files = []) => {
  const urls = [];
  const errors = [];

  for (const file of files) {
    try {
      const uploaded = await uploadMediaApi(file);
      if (!uploaded.url) {
        errors.push({ fileName: file.name });
        continue;
      }
      urls.push(uploaded.url);
    } catch (error) {
      errors.push({ fileName: file.name, message: error.message });
    }
  }

  return { urls, errors };
};
